import { Injectable, EventEmitter, OnInit } from '@angular/core';
import { SignalR } from 'ng2-signalr';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignalrService implements OnInit {

  private connected: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public factorHub: any;
  public connectionExists: boolean;
  public connectionEstablished: EventEmitter<boolean>;

  constructor(private _signalR: SignalR) {
    this.connectionEstablished = new EventEmitter<boolean>();
    this.connectionExists = false;
    this.startConnection();
  }

  ngOnInit() {
  }

  public connect() {
    return this.connected.asObservable();
  }

  public subscribeForEvent(symbol: string) {
    return this.factorHub.listenFor(symbol);
  }

  public invoke(name: string, ...args) {
    this.factorHub.invoke(name, ...args);
  }

  public startConnection() {
    console.log('start connection to signal R');
    this._signalR.connect()
      .then((c) => {
        this.connectionExists = true;
        this.factorHub = c;
        this.connectionEstablished.emit(true);
        this.connected.next(true);
        //console.log("SignalR connection established!!!! this.factorHub => ", this.factorHub);
      });
  }
}
